import { render, staticRenderFns } from "./ProfileCenter.vue?vue&type=template&id=ffd21eb6&scoped=true"
import script from "./ProfileCenter.vue?vue&type=script&lang=js"
export * from "./ProfileCenter.vue?vue&type=script&lang=js"
import style0 from "./ProfileCenter.vue?vue&type=style&index=0&id=ffd21eb6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ffd21eb6",
  null
  
)

export default component.exports